import {Routes} from './routes.constants';

// The bare dashboard route ("/home" or "/home/") renders no tab content.
export default function isBaseRoute(pathname: string) {
  return pathname === Routes.Base || pathname === `${Routes.Base}/`;
}
